const { __ } = wp.i18n;
const { Fragment, useEffect } = wp.element;
// import BMediaUpload from "../components/BMediaUpload/BMediaUpload";
import PanelItem from "../components/PanelItem/PanelItem";
import BColor from "./../components/BColor";

import BControlPro from "./../../../../wp-utils/v1/components/BControlPro/BControlPro.js";
import BMediaUpload from "./../../../../wp-utils/v1/components/BMediaUpload/BMediaUpload.js";

const { TabPanel, Panel, PanelBody, PanelRow, __experimentalNumberControl: NumberControl, ToggleControl, __experimentalUnitControl: UnitControl, SelectControl } = wp.components;
const { InspectorControls } = wp.blockEditor;

const Settings = (props) => {
  const {
    props: { attributes, setAttributes },
    isPremium,
  } = props;
  const { source, controls, download, primaryColor, bgColor, controlColor, poster, skin, title, artist, repeat, radius, autoplay, muted, loader, seekTime, startTime, width } = attributes;

  const handleControl = (control) => {
    const newControls = { ...controls };
    newControls[control] = !newControls[control];
    setAttributes({ controls: newControls });
  };

  const controlSettings = ["Restart", "Rewind", "Play", "Fast Forward", "Progress", "Duration", "Current Time", "Mute", "Volume", "Settings", "Download"];

  const skins = ["Default", "Fusion", "Stamp", "Wave", "Card 1", "Card 2", "Simple 1", "Simple 2"];

  useEffect(() => {
    if (!primaryColor) {
      setAttributes({ primaryColor: window.h5apEditor?.color?.primary, bgColor: window.h5apEditor?.color?.bg });
    }
  }, []);

  return (
    <InspectorControls>
      <TabPanel
        className="bPSS"
        activeClass="active-tab"
        //onSelect={ onSelect }
        tabs={[
          {
            name: "settings",
            title: "Settings",
            className: "general btTab",
          },
          {
            name: "controls",
            title: "Controls",
            className: "slider btTab",
          },
          {
            name: "style",
            title: "Style",
            className: "style btTab",
          },
        ]}
      >
        {(tab) => {
          return (
            <span>
              {tab.name == "settings" && (
                <span>
                  <Panel>
                    <PanelBody>
                      <BControlPro
                        isPremium={isPremium}
                        Component={SelectControl}
                        // labelPosition="side"
                        label={__("Skin", "h5ap")}
                        options={skins.map((item) => ({ label: item, value: item.replace(" ", "-") }))}
                        value={skin}
                        onChange={(skin) => setAttributes({ skin })}
                      />
                      {/* <PanelRow className="skin"> */}
                      {/* <label className="label">{__("Skin", "h5ap")}</label> */}
                      {/* <BUnit value={skin} units={} onChange={(skin) => setAttributes({ skin })} /> */}
                      {/* </PanelRow> */}
                      <BMediaUpload label={__("Audio Source", "h5ap")} type={["audio"]} value={source} onSelect={(source) => setAttributes({ source })} placeholder="Audio URL" />

                      {["Fusion", "Wave", "Card-1", "Card-2", "Simple-2"].includes(skin) && (
                        <Fragment>
                          <BMediaUpload label={__("Poster/Thumbnail", "h5ap")} value={poster} type={["image"]} onSelect={(poster) => setAttributes({ poster })} />
                        </Fragment>
                      )}

                      {skin !== "Default" && (
                        <Fragment>
                          <PanelItem label={__("Title", "h5ap")} value={title} placeholder={__("Audio Title", "h5ap")} onChange={(title) => setAttributes({ title })} />
                          <PanelItem label={__("Artist", "h5ap")} value={artist} placeholder={__("Artist", "h5ap")} onChange={(artist) => setAttributes({ artist })} />
                        </Fragment>
                      )}

                      <ToggleControl label={__("Repeat", "h5ap")} id="repeat" checked={repeat} onChange={() => setAttributes({ repeat: !repeat })} />

                      <ToggleControl label={__("Autoplay", "h5ap")} id="autoplay" checked={autoplay} onChange={() => setAttributes({ autoplay: !autoplay })} />

                      <ToggleControl label={__("Muted", "h5ap")} id="muted" checked={muted} onChange={() => setAttributes({ muted: !muted })} />
                      <ToggleControl label={__("Loader", "h5ap")} id="loader" checked={loader} onChange={() => setAttributes({ loader: !loader })} />

                      {skin === "Fusion" && <ToggleControl label={__("Enable Dlownlaod", "h5ap")} id="download" checked={download} onChange={() => setAttributes({ download: !download })} />}
                      <BControlPro
                        label={__("Seek Time", "h5ap")}
                        isPremium={isPremium}
                        Component={NumberControl}
                        isShiftStepEnabled={true}
                        onChange={(seekTime) => setAttributes({ seekTime: parseInt(seekTime) })}
                        shiftStep={1}
                        value={seekTime}
                      />
                      <PanelRow>
                        <BControlPro
                          label={__("Start Time", "h5ap")}
                          isPremium={isPremium}
                          Component={NumberControl}
                          isShiftStepEnabled={true}
                          onChange={(startTime) => setAttributes({ startTime: parseInt(startTime) })}
                          shiftStep={1}
                          value={startTime}
                        />
                      </PanelRow>
                    </PanelBody>
                  </Panel>
                </span>
              )}
              {tab.name == "controls" && (
                <Panel>
                  <PanelBody>
                    {skin === "Default"
                      ? controlSettings.map((item) => {
                          const control = item.toLocaleLowerCase()?.replace(" ", "-");
                          return (
                            <BControlPro
                              key={control}
                              label={__(item, "h5ap")}
                              isPremium={isPremium}
                              Component={ToggleControl}
                              id={control}
                              checked={controls[control]}
                              onChange={() => handleControl(control)}
                            />
                          );
                        })
                      : __("Controls are available only Default skin", "h5ap")}
                  </PanelBody>
                </Panel>
              )}
              {tab.name == "style" && (
                <span>
                  <Panel>
                    <PanelBody>
                      <PanelRow>
                        <UnitControl
                          label={__("Width", "h5ap")}
                          labelPosition="side"
                          units={[
                            { value: "px", label: "px", default: 500 },
                            { value: "%", label: "%", default: 100 },
                          ]}
                          onChange={(width) => setAttributes({ width })}
                          value={typeof width === "object" ? `${width.number}${width.unit}` : width}
                          isResetValueOnUnitChange={true}
                        />
                      </PanelRow>
                      {["Default", "Fusion", "Stamp", "Wave", "Card 2", "Simple 1"].includes(skin.replace("-", " ")) && (
                        <PanelRow>
                          <UnitControl
                            label={__("Radius", "bpm")}
                            units={[
                              { label: "px", value: "px", default: 0 },
                              { label: "%", value: "%", default: 0 },
                              { label: "em", value: "em", default: 0 },
                            ]}
                            onChange={(radius) => setAttributes({ radius })}
                            value={typeof radius === "object" ? `${radius.number}${radius.unit}` : radius}
                            isResetValueOnUnitChange={true}
                            labelPosition="side"
                          />
                        </PanelRow>
                      )}

                      {["Default", "Fusion", "Stamp", "Wave", "Simple 1", "Simple 2"].includes(skin.replace("-", " ")) && (
                        <BControlPro
                          label={__("Primary Color", "h5ap")}
                          isPremium={isPremium}
                          Component={BColor}
                          value={primaryColor}
                          defaultColor={window.h5apEditor?.color?.primary}
                          onChange={(primaryColor) => setAttributes({ primaryColor })}
                        />
                      )}
                      {["Default", "Stamp", "Wave", "Card 1", "Card 2", "Simple 1", "Simple 2"].includes(skin.replace("-", " ")) && (
                        <Fragment>
                          <BControlPro
                            label={__("Background Color", "h5ap")}
                            isPremium={isPremium}
                            Component={BColor}
                            value={bgColor}
                            defaultColor={window.h5apEditor?.color?.bg}
                            onChange={(bgColor) => setAttributes({ bgColor })}
                          />
                        </Fragment>
                      )}
                      {["Default"].includes(skin.replace("-", " ")) && (
                        <Fragment>
                          <BControlPro
                            label={__("Control Color", "h5ap")}
                            isPremium={isPremium}
                            Component={BColor}
                            value={controlColor}
                            defaultColor={"#4a5464"}
                            onChange={(controlColor) => setAttributes({ controlColor })}
                          />
                        </Fragment>
                      )}
                    </PanelBody>
                  </Panel>
                </span>
              )}
            </span>
          );
        }}
      </TabPanel>
    </InspectorControls>
  );
};

export default Settings;
